import React from 'react';
import ItsolutionsCard from './itsolutionsCard';

const data = [
  {
    img: '/images/outsourcing-sistemas.png',
    title: '',
    description1: '',
    description2: '',
    items: [],
    videoUrl: '',
  },

  {
    img: '',
    title: '',
    description1: 'Sicons Perú es tu aliado estratégico en el mundo de la tecnología. No solo implementamos y comercializamos sistemas de vanguardia, sino que también ofrecemos consultoría especializada para que puedas aprovechar al máximo las herramientas tecnológicas y alcanzar tus objetivos de negocio.',
    description2: 'Nuestro equipo de expertos te guiará en cada paso del camino, desde la elección de la solución adecuada hasta la implementación y el soporte continuo. Confía en nosotros para optimizar tus procesos, mejorar tu eficiencia y llevar tu empresa al siguiente nivel.',
    items: [],
    videoUrl: '',
  },

];

const Itsolutions: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-8 lg:px-16 my-12 lg:my-24">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-blue mb-8">TI Soluciones</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
        {data.map((item, index) => (
          <ItsolutionsCard
            key={index}
            img={item.img}
            title={item.title}
            description1={item.description1}
            description2={item.description2}
            items={item.items}
            videoUrl={item.videoUrl}
          />
        ))}
      </div>
    </div>
  );
};

export default Itsolutions;
